// APP LANGUAGE CONFIG
export const nepaliLanguage = {
  isNepali: true,
  key: {
    home: "गृह",
    contact: "सम्पर्क",
    whoweare: "हाम्रो बारेमा",
    ourteam: "हाम्रो समूह",
    currentResearch: "वर्तमान अनुसन्धान",
    research: "अनुसन्धान",
    events: "कार्यक्रम",
    recentEvents: "भर्खरका कार्यक्रमहरू",
    moreEvents: "थप कार्यक्रमहरू",
    outputs: "परिणामहरू",
    publication: "प्रकाशन",
    newsletter: "समाचार पत्र",
    news: "समाचार",
    openinghours: "खुल्ने समय",
    openingtime: "बिहान ९ बजे देखि साँझ ४ बजे सम्म",
    telephone: "(+९७७) २६-४०५१११, ९८६५५५८७५९",
    introduction: "परिचय",
    readmore: "थप पढ्नुहोस्",
    send: "पठाउनुहोस्",
    imagegallery: "तस्बिरहरु",
    seeall: "सबै हेर्नुहोस्",
    view: "हेर्नुहोस्",
    download: "डाउनलोड गर्नुहोस्",
    article: "लेख",
    mediaOutput: "संचार माध्यम",
    notfound: "404 पृष्ठ छैन",
    notfounddesc: "तपाईंले अनुरोध गर्नुभएको पृष्ठ फेला परेन",
    scrolltotop: "शीर्षमा स्क्रोल गर्नुहोस्",
    whatwedo: `हामी के गर्छौ?`,
    collaborators: "सहयोगीहरु",
    newsupdate: "समाचार अपडेट",
    disclaimer: "अस्वीकरण",
    quickLinks: "द्रुत लिंक",
    nirc: "एनआईआरसी",
    headerTeamDesc:
      "नेपाल इन्जरी अनुसन्धान केन्द्रमा विविध विधामा दक्षता हासिल गरेका अनुसन्धानकर्ताहरुको समूह रहेको छ जसको कार्यक्षमताले नेपालमा इन्जरी रोकथाममा टेवा पुर्याउदछ।",
    homepage: {
      introduction:
        "नेपाल  इन्जरी अनुसन्धान केन्द्र (एन आइ आर सी,) यू. के. नेशनल इन्स्तिचुत फर हेल्थ रिसर्च ग्लोबल हेल्थ रिसर्चद्वारा वित्त पोषित, चार वर्षीय अनुसन्धान सहकार्य हो | एन आइ आर सी, काठमाडौं मेडिकल कलेज (के एम सी) र युनिवार्सिती अफ द वेस्ट अफ इंग्ल्यान्ड , ब्रिस्टल, बेलायतको बीच साझेदारी हो। ",
      firsth1: "नेपाल  इन्जरी अनुसन्धान केन्द्रमा",
      secondh1: "स्वागत छ",
      introductionfull: `नेपाल  इन्जरी अनुसन्धान केन्द्र (एन आइ आर सी,) यू. के. नेशनल इन्स्तिचुत फर हेल्थ रिसर्च ग्लोबल हेल्थ रिसर्चद्वारा वित्त पोषित, चार वर्षीय अनुसन्धान सहकार्य हो | एन आइ आर सी, काठमाडौं मेडिकल कलेज (के एम सी) र युनिवार्सिती अफ द वेस्ट अफ इंग्ल्यान्ड , ब्रिस्टल, बेलायतको बीच साझेदारी हो। एन आइ आर सी को उद्देश्य नेपालमा घाइतेको रोकथाम र घाइतेहरूको पहिलो प्रतिक्रियामा सुधारको लागि चाहिने नीति तथा कार्यहरुमा परिवर्तनको लागि तथ्य विकास गर्नु हो |
      नेपाल  इन्जरी अनुसन्धान केन्द्र, काठमाडौँ मेडिकल कलेजको कम्युनिटी मेडिसिन विभाग, दुवाकोट क्याम्पस अन्तर्गत पर्दछ | हाम्रा सहकार्यहरु: मदर एंड इन्फ्यांत रिसर्च एक्तिवितिज (मिरा), नेपाल रेड क्रस सोसाइटी, स्वतन्त्रता अभियान, सेफ क्रसिन्ग्स, द सेन्टर फर इन्जरी प्रिभेन्शन रिसर्च बंगलादेश (सि आइ पि आर बि) र युनिभर्सिटी अफ ब्रिस्टल, यू के`,
    },
    contactpage: {
      writetous: "हामीलाई लेख्नुहोस् यदि तपाईंसँग प्रश्नहरू छन् भने",
      name: "नाम",
      namePlaceholder: "तपाइँको पुरा नाम",
      phone: "फोन नम्बर",
      phonePlaceholder: "तपाइँको फोन नम्बर",
      email: "ईमेल",
      emailPlaceholder: "तपाइँको इ-मेल ठेगाना",
      subject: "विषय",
      subjectPlaceholder: "विषय",
      message: "सन्देश",
      messagePlaceholder: "सन्देश...",
      send: "पठाउनुहोस्",
      fulladdress:
        "नेपाल  इन्जरी अनुसन्धान केन्द्र(एनआईआरसी), सामुदायिक चिकित्सा विभाग, काठमाडौं मेडिकल कलेज (के.यम.सी.)",
      pobox: "पोष्ट बक्स २१२६६, दुवाकोट, भक्तपुर, नेपाल",
      telephone: "+९७७ ९८१७०८४८३७",
      emailaddress: "nirc.kmc@gmail.com",
      address1: "नेपाल  इन्जरी अनुसन्धान केन्द्र(एनआईआरसी),",
      address2: "सामुदायिक चिकित्सा विभाग,",
      address3: "काठमाडौं मेडिकल कलेज (के.यम.सी.),",
      address4: "पोष्ट बक्स २१२६६, दुवाकोट, भक्तपुर, नेपाल",
    },
    researchDetail: {
      projectTitle: "परियोजना शिर्षक",
      background: "पृष्ठभूमिः",
      projectAim: "परियोजनाको उद्धेश्य",
      methods: "विधीहरु",
      impact: "अपेक्षित प्रभाव",
      team: "अध्ययन टोली",
      fullTextArticle: "अध्ययनको विस्तृत विवरण यहाँ उपलब्ध छ",
    },
  },
};

export const englishLanguage = {
  isNepali: false,
  key: {
    home: "Home",
    contact: "Contact Us",
    whoweare: "About Us",
    ourteam: "Our Team",
    currentResearch: "Current Research",
    research: "Research",
    events: "Events",
    recentEvents: "Recent Events",
    moreEvents: "More Events",
    outputs: "Outputs",
    publication: "Publication",
    newsletter: "News Letter",
    news: "News & Notices",
    openinghours: "Opening hours",
    openingtime: "9AM to 4PM",
    telephone: "(+977) 26-405103, 9817084837",
    introduction: "Introduction",
    readmore: "Read More",
    send: "Send",
    imagegallery: "Image Gallery",
    seeall: "See All",
    view: "View",
    download: "Download",
    article: "Article",
    mediaOutput: "Media Outputs",
    pressRelease: "Press Release",
    notfound: "404 Page Not Found",
    notfounddesc: "The page you requested not found",
    scrolltotop: "Scroll To Top",
    whatwedo: `What We Do?`,
    collaborators: "Collaborators",
    newsupdate: "News Update",
    disclaimer: "DISCLAIMER",
    quickLinks: "Quick Links",
    nirc: "ARSP",
    headerTeamDesc:
      "Nepal Injury Research Centre has a strong multidisciplinary team who come from various academic backgrounds and are using their varied skillset to contribute to the field of Injury Prevention in Nepal.",
    homepage: {
      introduction: `Agricultural Research Station, Pakhribas is a leading center for the agriculture research
      and development under Nepal Agricultural Research Council (NARC) in the eastern hill
      region of Nepal.The station was initially established in 1972 as a training centre with
      the support of British Government.`,
      firsth1: "Welcome to",
      secondh1: "Agricultural Research Station (ARSP)",
      introductionfull: `Agricultural Research Station, Pakhribas is a leading center for the agriculture research
      and development under Nepal Agricultural Research Council (NARC) in the eastern hill
      region of Nepal. The station was initially established in 1972 as a training centre with
      the support of British Government. Later, the station was handed over to the Nepal
      Agricultural Research Council (NARC) in 1998. Since then, the station has been
      involving in the research and studies on multi-sectors of agriculture and livestock for the
      technology generation and dissemination in the eastern hill regions of Nepal. The
      station has mandate to conduct agriculture research and development in 10 hill districts
      of Province-1. The mandated research command districts include: Dhankuta,
      Terhathum, Sankhuwasabha, Bhojpur, Ilam, Panchthar, Taplejung, Khotang,
      Okhaldhunga and Solukhumbu.
      It is located at Pakhribas Municipality, ward no-3, Dhankuta, between 27 0  2.98′ north
      latitude and 87 0  17.61′ east longitudes with the elevation of 1,315 to 2,025 m asl. The
      research farm occupies 92.8 ha area with south facing bari as well as khet land. It is
      situated at about 17 kilometer north-west of Dhankuta district headquarter.
      `,
    },

    contactpage: {
      writetous: "Write to Us If You Have Questions",
      name: "Name",
      namePlaceholder: "Your Full Name",
      phone: "Phone",
      phonePlaceholder: "Your Phone Number",
      email: "Email",
      emailPlaceholder: "Your Email Address",
      subject: "Subject",
      subjectPlaceholder: "Subject",
      message: "Message",
      messagePlaceholder: "Message...",
      send: "Send",
      fulladdress: "Agricultural Research Station, Pakhribas, Dhankuta",
      pobox: "Fax: (+977) 26-405111",
      telephone: "(+977) 26-405111, 9802726581",
      emailaddress: "arspakh@gmail.com",
      address1: "Agricultural Research Station(ARSP),",
      address2: "Pakhribas, Dhankuta",
      address3: "Kathmandu Medical College (KMC),",
      address4: "Fax: (+977) 26-405111",
    },
    researchDetail: {
      projectTitle: "Project Title",
      background: "Background",
      projectAim: "Project Aim",
      methods: "Methods",
      impact: "Anticipated Impact",
      team: "Study Team",
      fullTextArticle: "Full text article available at",
    },
  },
};

export const LANGUAGE_TYPE = {
  np: "nepali",
  en: "english",
};

// पृष्ठ
